import moment from 'moment'

const DAY_IN_MILLISECONDS = 86400000;
const MIN_NUM_DAYS_NEXT_REV = 181;
const MINIMUM_YEAR = 2020;

/**
 * Convert ISO String date into brazilian date format
 * @param {*} isoString ISO String date format
 */
export const convertDate = (isoString, showDay) => {
  let newDate = moment(isoString)
  return showDay ? newDate.format('DD/MM/YYYY') : newDate.format('MM/YYYY')
}

/**
 */
export const showCountDownDate = (lastDateSet) => {
  const result = {
    showCard: false,
    daysDiff: 0,
    error: false,
    message: '',
    revisionNow: false,
  };
  const currentTime = new Date().getTime();
  const aux = lastDateSet.indexOf('T');
  if (aux > 0) {
    const date = lastDateSet.substring(0, aux);
    const dateArray = date.split('-');
    const finalDate = new Date(
      dateArray[0],
      dateArray[1] - 1,
      dateArray[2],
      12,
      0,
      0,
      0,
    ).getTime();
    result.daysDiff = Math.round(
      (finalDate - currentTime) / DAY_IN_MILLISECONDS,
    );

    if (result.daysDiff < MIN_NUM_DAYS_NEXT_REV && result.daysDiff > 0) {
      result.showCard = true;
      result.revisionNow = result.daysDiff < 1;
    }
  } else {
    result.showCard = false
    result.error = true
    result.message = 'Invalid date format, correct format is : YYYY-MM-DDTHH:MM:SS.000+0000'
  }
  return result;
};

/**
 * Format numbers
 * @input - 10000
 * @output - 10.000
 * @author Roberto Vilas Boas - rvilas@br.ibm.com
 */
export const formatNumber = (number) => {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
};

/**
 * Check if vin is on valid year range
 * @param {*} modelYear chassi value
 */
export const isValidModelYear = (modelYear) => {
  return modelYear >= MINIMUM_YEAR
}
